/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { RemoveGraph };
class RemoveGraph {
    async do(edit, context) {
        if (edit.type !== "removegraph") {
            throw new Error(`Editor API integrity error: expected type "removegraph", received "${edit.type}" instead.`);
        }
        const { id } = edit;
        const { graph, mutable } = context;
        if (!graph.graphs || !graph.graphs?.[id]) {
            return {
                success: false,
                error: `Failed to remove graph: "${id}" does not exist.`,
            };
        }
        delete graph.graphs[id];
        if (!Object.keys(graph.graphs).length) {
            delete graph.graphs;
        }
        mutable.removeSubgraph(id);
        return {
            success: true,
            affectedModules: [],
            affectedNodes: [],
            affectedGraphs: [id],
        };
    }
}
//# sourceMappingURL=remove-graph.js.map